import { range } from "lodash";
import { getWidth } from "../common";

const columns = 14;
export default range(columns).map(current => {
  const field = `relay_mechanical_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
